import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'prompt', 'selected', 'filename']
  static classes = ['dragover']

  inputChanged() {
    const file = this.inputTarget.files[0]
    if (file) {
      this.filenameTarget.textContent = file.name
      this.promptTarget.classList.add('hidden')
      this.promptTarget.classList.remove('flex')
      this.selectedTarget.classList.remove('hidden')
      this.selectedTarget.classList.add('flex')
    } else {
      this.promptTarget.classList.remove('hidden')
      this.promptTarget.classList.add('flex')
      this.selectedTarget.classList.add('hidden')
      this.selectedTarget.classList.remove('flex')
    }
  }

  dragover(event) {
    event.preventDefault()
    this.element.classList.add(...this.dragoverClasses)
  }

  dragleave(event) {
    event.preventDefault()
    if (this.element.contains(event.relatedTarget)) return
    this.element.classList.remove(...this.dragoverClasses)
  }

  drop(event) {
    event.preventDefault()
    this.element.classList.remove(...this.dragoverClasses)
    this.inputTarget.files = event.dataTransfer.files
    this.inputChanged()
  }

  remove(event) {
    event.preventDefault()
    event.stopPropagation()
    this.inputTarget.value = ''
    this.inputChanged()
  }
}
